import React from 'react';
import { NextPage } from 'next';
import { CookiePolicy } from 'templates/company';
import { SEO } from 'templates/layout';

const Cookie: NextPage = () => {
  return (
    <>
      <SEO title="Cookie Policy" />
      <CookiePolicy />
    </>
  );
};

export default Cookie;
